import { getOrgById } from '@/api/org'
import logger from '@/utils/logger'
import {
  checkOrgDeleted,
  checkUserDeleted,
  isLkDisabledError,
  isPasswordChangeRequiredError,
} from '@/utils/orgCheck'

let verifiedPath = null

export default async function ({ store, redirect, route, from }) {
  // Nuxt перезапускает middleware и при изменении одного лишь query
  // (пагинация, шаги мастера настроек). Path и orgId при этом те же,
  // решение о доступе измениться не может, а повторные /me и /org/{id}
  // только плодят запросы и гонки обновления токена.
  if (
    verifiedPath === route.path &&
    from &&
    from.path === route.path &&
    store?.state?.auth?.user
  ) {
    return
  }

  // Проверяем авторизацию через токены
  const hasTokens =
    localStorage.getItem('accessToken') && localStorage.getItem('refreshToken')
  if (!hasTokens) {
    if (route?.path !== '/auth') {
      logger.warn('Нет токенов в localStorage, редирект на /auth', {
        from: route?.fullPath,
      })
      return redirect('/auth')
    }
    return
  }

  try {
    await store.dispatch('auth/getUser')
  } catch (error) {
    logger.error('Ошибка проверки пользователя через /me:', error)
    store.commit('auth/clearTokens')
    if (route?.path !== '/auth') {
      logger.warn('Сессия сброшена после сбоя /me, редирект на /auth', {
        from: route?.fullPath,
      })
      return redirect('/auth')
    }
    return
  }

  const user = store?.state?.auth?.user
  if (!user) {
    store.commit('auth/clearTokens')
    if (route?.path !== '/auth') {
      logger.warn('/me не вернул пользователя, редирект на /auth', {
        from: route?.fullPath,
      })
      return redirect('/auth')
    }
    return
  }

  // Временный пароль: org-роуты бэка отвечают 403 PASSWORD_CHANGE_REQUIRED,
  // пропускаем на страницу — layout покажет модалку смены пароля
  if (user.mustChangePassword === true) {
    verifiedPath = route.path
    return
  }

  // Проверяем доступ к организации (админы имеют доступ ко всем организациям)
  if (Array.isArray(user?.roles) && !user.roles.includes('admin')) {
    if (user?.employees?.length >= 1) {
      const userOrgs = user.employees.map((org) => org.orgId)
      const requestedOrg = parseInt(route.params.orgId)

      if (!userOrgs.includes(requestedOrg)) {
        const targetPath = `/org/${userOrgs[0]}/calendar`
        if (route.path !== targetPath) {
          logger.warn('Нет доступа к организации, редирект', {
            requestedOrg,
            userOrgs,
            targetPath,
          })
          return redirect(targetPath)
        }
      }

      if (requestedOrg) {
        try {
          await getOrgById(requestedOrg)
        } catch (error) {
          if (
            isLkDisabledError(error) ||
            isPasswordChangeRequiredError(error)
          ) {
            return
          }

          logger.error('Ошибка проверки организации:', error)
          // Удалённая орг или пользователь — сброс и редирект на /auth
          checkOrgDeleted(error, { store, redirect })
          checkUserDeleted(error, { store, redirect })
          logger.warn('Сбой проверки организации, редирект на /auth', {
            requestedOrg,
            status: error?.response?.status,
          })
          return redirect('/auth')
        }
      }
    } else if (route.path !== '/') {
      logger.warn('У пользователя нет организаций, редирект на /', {
        from: route?.fullPath,
      })
      return redirect('/')
    }
  }

  if (route.params.orgId) {
    try {
      await store.dispatch('business/loadOrganizationData', route.params.orgId)
    } catch (error) {
      logger.error('Ошибка загрузки настроек организации:', error)
      if (isLkDisabledError(error) || isPasswordChangeRequiredError(error)) {
        return
      }
      throw error
    }

    try {
      await store.dispatch('org/fetchForSidebar', route.params.orgId)
    } catch (error) {
      logger.error('Ошибка загрузки данных организации для сайдбара', error)
    }
  }

  verifiedPath = route.path
}
